










































import { Component, Prop, Vue } from "vue-property-decorator";
import { IFilmCategory as ICat } from "@/@types/cinema/film-category";
import StandartCategoryDd from "@/components/app/dropdowns/standart-category-dd.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import ButtonCart from "@/components/buttons/button-cart.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

@Component({
  components: {
    "dd-category": StandartCategoryDd,
    InputSearch,
    ButtonCart,
    ButtonBack,
  },
})
export default class CinemaListHeader extends Vue {
  @Prop({ type: Number, default: 0 }) f_length!: number;
  @Prop({ type: Number, default: 0 }) c_length!: number;
  @Prop({ type: String, default: "" }) category_id!: string;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICat>;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
}
